import gql from 'graphql-tag'
import { apolloClientPrivate } from '../../../graphql/apolloClient'

interface IResponse {
  admin: {
    organisation: {
      isSubdomainAvailable: boolean
    }
  }
}

const QUERY = gql`
  query isSubdomainAvailable($subdomainName: String!) {
    admin {
      organisation {
        id
        isSubdomainAvailable(subdomainName: $subdomainName)
      }
    }
  }
`

export default async (subdomainName: string): Promise<boolean> => {
  const response = await apolloClientPrivate.query<IResponse>({
    variables: {
      subdomainName
    },
    query: QUERY
  })

  return response.data.admin.organisation.isSubdomainAvailable
}
